module.exports = __webpack_public_path__ + "static/media/education-list.7a6454fb.png";